import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8772a0f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "section",
  name: "公司介绍"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "section",
  name: "团队介绍"
}
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "box_team" }
const _hoisted_17 = { class: "team" }
const _hoisted_18 = { class: "team_name" }
const _hoisted_19 = {
  class: "section",
  name: "公司发展里程碑"
}
const _hoisted_20 = { class: "container" }
const _hoisted_21 = {
  class: "section section_max",
  name: "企业文化"
}
const _hoisted_22 = { class: "container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "使命", -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 让计算像电一样"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 随需使用 ")
], -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "愿景", -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 10年帮助10万企业"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 将计算效率提升10倍 ")
], -1 /* HOISTED */))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "价值观", -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 客户第一，服务优先"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 创新创造价值"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 高人才密度带来创新"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Keep Moving ")
], -1 /* HOISTED */))
const _hoisted_32 = {
  class: "section",
  name: "联系我们"
}
const _hoisted_33 = { class: "container" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "北京星汉未来", -1 /* HOISTED */))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "网络科技有限公司", -1 /* HOISTED */))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系电话：010-53655900", -1 /* HOISTED */))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系地址：北京市海淀区知春路23号", -1 /* HOISTED */))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系邮箱：market@galaxy-future.com", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_timeline = _resolveComponent("a-timeline")!
  const _component_PhoneOutlined = _resolveComponent("PhoneOutlined")!
  const _component_EnvironmentOutlined = _resolveComponent("EnvironmentOutlined")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_typography_title, { level: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("公司介绍")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _createTextVNode("COMPANY PROFILE")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_paragraph, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('星汉未来（Galaxy-Future）创立于2021年6月，作为一家AI应用平台厂商，' +
          '提供AI应用管理、AI算力管理等全方位AI平台服务，以及AI数字人、AI绘画等AI应用服务。' +
          '2023年，公司荣获“北京市专精特新中小企业”及“国家高新技术企业”称号。' +
          '凭借丰富的专利技术和不懈的产品创新，星汉未来致力于推动AI应用的落地和普及，让AI技术成为企业的增长新动力。'))
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode("<div class=\"box_video\" :class=\"{active:expand.active}\">"),
        _createCommentVNode("  <video ref=\"video\" :src=\"href.video\""),
        _createCommentVNode("         controls preload=\"metadata\" />"),
        _createCommentVNode("  <i class=\"video_play\""),
        _createCommentVNode("     @click=\"clickPlayVideo\" />"),
        _createCommentVNode("</div>"),
        _createCommentVNode("<a-typography-paragraph>"),
        _createCommentVNode("  {{"),
        _createCommentVNode("    '星汉未来入选2023年第三季度北京市专精特新中小企业，作为一家高新科技企业，星汉未来拥有雄厚的技术研发实力，被评选为中关村高新技术企业、2022中国数智化创新TOP50企业。' +"),
        _createCommentVNode("    '此外，其自主研发的数据物流引擎DTExpress、指标治理引擎CudgX、算力共享池、快速规格压测、快速流量压测等均获得发明专利授权，' +"),
        _createCommentVNode("    '云原生智能运维平台SchedulX、Serverless平台应用托管产品InfraPilot等产品已获得软著认证。'"),
        _createCommentVNode("  }}"),
        _createCommentVNode("</a-typography-paragraph>"),
        _createVNode(_component_a_typography_paragraph, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('作为一家高新科技企业，星汉未来坚持技术创新，不断打造专业的技术产品服务力，' +
          '2022年被评选为中关村高新技术企业、2023年获得国家高新技术企业、北京市专精特新中小企业等荣誉。' +
          '这是企业在科技成果水平和产品技术含量取得里程碑式的荣誉，也是对企业技术实力的有力证明。'))
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_row, {
          class: "box_image",
          type: "flex",
          justify: "space-around",
          gutter: [20,10]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              md: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_12
                }, null, 8 /* PROPS */, _hoisted_3)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              md: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_1
                }, null, 8 /* PROPS */, _hoisted_4)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              md: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_13
                }, null, 8 /* PROPS */, _hoisted_5)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_paragraph, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('星汉未来注重核心技术自主研发及创新，' +
          '其自主研发的数据物流引擎DTExpress、指标治理引擎CudgX、快速规格压测、快速流量压测、算力共享池等均获得发明专利授权，' +
          '云原生智能运维平台SchedulX、Serverless平台应用托管产品InfraPilot等产品已获得软著认证。'))
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_row, {
          class: "box_image",
          type: "flex",
          justify: "space-around",
          gutter: [20,10]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              md: 4
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_7
                }, null, 8 /* PROPS */, _hoisted_6)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              md: 4
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_8
                }, null, 8 /* PROPS */, _hoisted_7)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              md: 4
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_9
                }, null, 8 /* PROPS */, _hoisted_8)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              md: 4
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_10
                }, null, 8 /* PROPS */, _hoisted_9)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              md: 4
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_11
                }, null, 8 /* PROPS */, _hoisted_10)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_paragraph, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('同时，星汉未来致力于云原生落地，积极推动开源社区生态发展，' +
          '已正式入选成为FinOps产业推进方阵共建单位、开源 GitOps 产业联盟会员、FinOps 产业标准生态联盟首批会员。' +
          '2022年6月，经中国通信企业协会常务理事会评估，星汉未来正式加入中国通信企业协会，成为通信网络运营专业委员会会员单位。' +
          '2022年被评为2022中国数智化创新TOP50企业。'))
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_row, {
          class: "box_image",
          gutter: [20,10]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              md: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_4
                }, null, 8 /* PROPS */, _hoisted_11)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              md: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_5
                }, null, 8 /* PROPS */, _hoisted_12)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              md: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image_6
                }, null, 8 /* PROPS */, _hoisted_13)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_a_typography_title, { level: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("团队介绍")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _createTextVNode("TEAM INTRODUCTION")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_paragraph, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('星汉未来研发团队成员来自于微博、阿里、华为、字节等知名企业核心团队。' +
          'CEO 为前微博基础架构部总负责人，负责核心业务 10 年以上。'))
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_a_divider, { orientation: "left" }, {
            default: _withCtx(() => [
              _createTextVNode("管理团队")
            ]),
            _: 1 /* STABLE */
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.team, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createTextVNode(_toDisplayString(item.name), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString(item.position), 1 /* TEXT */)
              ]),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (v) => {
                  return (_openBlock(), _createElementBlock("li", null, _toDisplayString(v), 1 /* TEXT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_a_typography_title, { level: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("公司发展里程碑")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _createTextVNode("COMPANY MILESTONES")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_timeline, { class: "box_time" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.time, (item) => {
              return (_openBlock(), _createBlock(_component_a_timeline_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: 24,
                        md: 5
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.date), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_a_col, {
                        xs: 24,
                        md: 19
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.value), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_a_typography_title, { level: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("企业文化")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _createTextVNode("CORPORATE CULTURE")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_row, { class: "box_culture" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              lg: 8
            }, {
              default: _withCtx(() => [
                _hoisted_23,
                _hoisted_24,
                _hoisted_25
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              lg: 8
            }, {
              default: _withCtx(() => [
                _hoisted_26,
                _hoisted_27,
                _hoisted_28
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, {
              xs: 24,
              lg: 8
            }, {
              default: _withCtx(() => [
                _hoisted_29,
                _hoisted_30,
                _hoisted_31
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_a_typography_title, { level: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("联系我们")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_typography_title, { level: 5 }, {
          default: _withCtx(() => [
            _createTextVNode("CONTACT US")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_row, { class: "box_contact" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              xs: 24,
              md: { offset: 6, span: 12 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_typography_title, { level: 5 }, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    (_ctx.$Store.Public().isGridMatch('<',_ctx.$Enum.GridEnum.MD))
                      ? (_openBlock(), _createElementBlock("br", _hoisted_35))
                      : _createCommentVNode("v-if", true),
                    _hoisted_36
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_PhoneOutlined, { rotate: 90 }),
                    _hoisted_37
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_EnvironmentOutlined),
                    _hoisted_38
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_MailOutlined),
                    _hoisted_39
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode("<a-col :xs=\"24\" :md=\"12\">"),
            _createCommentVNode("    <div class=\"qr\">"),
            _createCommentVNode("        <img alt=\"\""),
            _createCommentVNode("             :src=\"file.ImageQR\" />"),
            _createCommentVNode("        <p>关注微信公众号</p>"),
            _createCommentVNode("        <p>GalaxyFutureTech</p>"),
            _createCommentVNode("    </div>"),
            _createCommentVNode("</a-col>")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}